export default "__VITE_ASSET__0c1c374c__"